export const getContainerStyles = (currentTheme, isRTL) => ({
  minHeight: "100vh",
  background: currentTheme?.background?.gradient || "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  fontFamily: currentTheme?.fonts?.primary || "Arial, sans-serif",
  position: "relative",
  overflow: "hidden",
  transition: "all 0.3s ease",
  direction: isRTL ? "rtl" : "ltr",
});

export const getBackgroundOverlayStyles = (currentTheme) =>
  currentTheme?.background?.overlay || {};

export const getDecorativeContainerStyles = (currentTheme) =>
  currentTheme?.background?.decorative?.container || {};

export const getCircle1Styles = (currentTheme) =>
  currentTheme?.background?.decorative?.circle1 || {};

export const getCircle2Styles = (currentTheme) =>
  currentTheme?.background?.decorative?.circle2 || {};

export const getGlobalStyles = (currentTheme, isRTL, sidebarOpen) => `
    * {
      box-sizing: border-box;
    }

    body {
      margin: 0;
      padding: 0;
      font-family: ${isRTL ? "'Cairo', 'Tajawal', 'Segoe UI', " : ""}${currentTheme?.fonts?.primary || "Arial, sans-serif"};
      direction: ${isRTL ? 'rtl' : 'ltr'};
    }

    input::placeholder {
      color: ${currentTheme?.colors?.textSecondary || "#666"};
    }

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      background: ${currentTheme?.colors?.scrollbar?.track || "#f1f1f1"};
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb {
      background: ${currentTheme?.colors?.scrollbar?.thumb || "#c1c1c1"};
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: ${currentTheme?.colors?.scrollbar?.thumbHover || "#a8a8a8"};
    }

    /* Responsive Design */
    @media (max-width: 768px) {
      .mo3ti-sidebar {
        width: 100% !important;
        ${isRTL ? 'right' : 'left'}: ${sidebarOpen ? "0" : "-100%"} !important;
        z-index: 1000;
      }

      .mo3ti-main {
        ${isRTL ? 'margin-right' : 'margin-left'}: 0 !important;
      }

      .mo3ti-topbar {
        padding: 12px 16px !important;
      }

      .mo3ti-content {
        padding: 20px 16px !important;
      }

      .mo3ti-search {
        width: 200px !important;
      }
    }

    @media (max-width: 480px) {
      .mo3ti-content {
        padding: 16px 12px !important;
      }

      .mo3ti-search {
        width: 150px !important;
      }
    }

    /* RTL Specific Adjustments */
    [dir="rtl"] .mo3ti-sidebar {
      ${isRTL ? 'right' : 'left'}: 0;
      ${isRTL ? 'left' : 'right'}: auto;
    }

    [dir="rtl"] .mo3ti-main {
      ${isRTL ? 'margin-right' : 'margin-left'}: 280px;
      ${isRTL ? 'margin-left' : 'margin-right'}: 0;
    }

    /* Smooth transitions for RTL switch */
    .mo3ti-sidebar,
    .mo3ti-main,
    .mo3ti-content {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
  `;
